module.exports = __webpack_public_path__ + "img/avatar-7.7212d8bf.jpg";